module.exports = __webpack_public_path__ + "img/F4b.f2c2907b.svg";